var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[_vm.name],style:(_vm.mainCssVars)},[_c('grid',{class:[`${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        gap: '6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        gap: '10px',
      },
    ]}},[_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__content`],attrs:{"reverse":_vm.reverse,"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 3, width: 9 },
        { size: 1, x: 1, width: 12, reverse: true },
        { size: 3, x: 14, y: 1, width: 9, reverse: true },
      ]}},[_c('a-copy',{class:`${_vm.name}__copy`,attrs:{"cms":_vm.cms}})],1),_vm._v(" "),_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__media`],attrs:{"reverse":_vm.reverse,"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 13, width: 13 },
        { size: 1, x: 1, width: 12, reverse: true },
        { size: 3, x: 1, y: 1, width: 12, reverse: true },
      ]}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.hasVideo)?_c('a-video',{class:`${_vm.name}__video`,attrs:{"cms":_vm.cms}}):(!_vm.hasVideo && (_vm.cms.image || {}).filename)?_c('a-image-v2',{class:`${_vm.name}__image`,attrs:{"src":_vm.cms.image.filename,"alt":_vm.cms.image.alt,"layout":[
            { size: 0, bound: 667, ratio: [740, 833] },
            { size: 1, bound: 740, ratio: [740, 833] },
            { size: 2, bound: 740, ratio: [740, 833] },
            { size: 3, bound: 740, ratio: [740, 833] },
          ]}}):_vm._e()],1)],1)],1),_vm._v(" "),_vm._l((_vm.cms.battenberg),function(item){return _c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],key:item._uid,tag:"component",class:`${_vm.name}__battenberg`,attrs:{"cms":item}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }